import { render, staticRenderFns } from "./CardsGrid.vue?vue&type=template&id=0dc0e008&scoped=true"
import script from "./CardsGrid.vue?vue&type=script&lang=js"
export * from "./CardsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc0e008",
  null
  
)

export default component.exports